"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamApi = exports.ParticipatoryStatus = exports.MemberStateCode = exports.TeamRole = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var TeamRole;
(function (TeamRole) {
    TeamRole["Admin"] = "admin";
    TeamRole["Member"] = "member";
})(TeamRole = exports.TeamRole || (exports.TeamRole = {}));
var MemberStateCode;
(function (MemberStateCode) {
    MemberStateCode["Admin"] = "admin";
    MemberStateCode["TeamMember"] = "teamMember";
    MemberStateCode["InvitePending"] = "invitePending";
    MemberStateCode["InviteExpired"] = "inviteExpired";
})(MemberStateCode = exports.MemberStateCode || (exports.MemberStateCode = {}));
var ParticipatoryStatus;
(function (ParticipatoryStatus) {
    ParticipatoryStatus["Ok"] = "ok";
    ParticipatoryStatus["Banned"] = "banned";
})(ParticipatoryStatus = exports.ParticipatoryStatus || (exports.ParticipatoryStatus = {}));
function TeamApiAxiosParamCreator(configuration) {
    return {
        deleteAnonymousMember(teamId, email, options = {}) {
            if (teamId === null || teamId === undefined) {
                throw new base_1.RequiredError("teamId", "Required parameter teamId was null or undefined when calling deleteAnonymousMember.");
            }
            if (email === null || email === undefined) {
                throw new base_1.RequiredError("email", "Required parameter email was null or undefined when calling deleteAnonymousMember.");
            }
            const localVarPath = `/account/team/members/anonymous/{teamId}/{email}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getTeam(options = {}) {
            const localVarPath = `/account/team`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMember(memberId, options = {}) {
            if (memberId === null || memberId === undefined) {
                throw new base_1.RequiredError("memberId", "Required parameter memberId was null or undefined when calling deleteMember.");
            }
            const localVarPath = `/account/team/members/{memberId}`.replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        insertMember(lightMember, options = {}) {
            if (lightMember === null || lightMember === undefined) {
                throw new base_1.RequiredError("LightMember", "Required parameter LightMember was null or undefined when calling insertMember.");
            }
            const localVarPath = `/account/team/members`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof lightMember !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(lightMember !== undefined ? lightMember : {})
                : lightMember || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        acceptInvitation(Accept, options = {}) {
            if (Accept === null || Accept === undefined) {
                throw new base_1.RequiredError("Accept", "Required parameter Accept was null or undefined when calling acceptInvitation.");
            }
            const localVarPath = `/account/team/accept`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof Accept !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(Accept !== undefined ? Accept : {})
                : Accept || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function TeamApiFp(configuration) {
    return {
        acceptInvitation(Accept, options) {
            const localVarAxiosArgs = TeamApiAxiosParamCreator(configuration).acceptInvitation(Accept, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        deleteAnonymousMember(teamId, email, options) {
            const localVarAxiosArgs = TeamApiAxiosParamCreator(configuration).deleteAnonymousMember(teamId, email, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        deleteMember(memberId, options) {
            const localVarAxiosArgs = TeamApiAxiosParamCreator(configuration).deleteMember(memberId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        insertMember(LightMember, options) {
            const localVarAxiosArgs = TeamApiAxiosParamCreator(configuration).insertMember(LightMember, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getTeam(options) {
            const localVarAxiosArgs = TeamApiAxiosParamCreator(configuration).getTeam(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class TeamApi extends base_1.BaseAPI {
    acceptInvitation(Accept, options) {
        return TeamApiFp(this.configuration).acceptInvitation(Accept, options)(this.axios, this.basePath);
    }
    deleteAnonymousMember(teamId, email, options) {
        return TeamApiFp(this.configuration).deleteAnonymousMember(teamId, email, options)(this.axios, this.basePath);
    }
    deleteMember(memberId, options) {
        return TeamApiFp(this.configuration).deleteMember(memberId, options)(this.axios, this.basePath);
    }
    insertMember(LightMember, options) {
        return TeamApiFp(this.configuration).insertMember(LightMember, options)(this.axios, this.basePath);
    }
    getTeam(options) {
        return TeamApiFp(this.configuration).getTeam(options)(this.axios, this.basePath);
    }
}
exports.TeamApi = TeamApi;
